import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const PoolKids = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="pool-kids"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M55.959 46.759c-2.61-2.345-6.843-2.345-9.454 0l-.02.018-.02.019c-2.611 2.345-6.844 2.345-9.454 0l-.02-.019-.021-.018c-2.61-2.345-6.843-2.345-9.454 0l-.02.018-.02.019c-2.61 2.345-6.843 2.345-9.454 0l-.02-.019-.02-.018c-2.611-2.345-6.844-2.345-9.455 0l-.02.018-.02.019A6.799 6.799 0 016 48.206V56h50v-9.204l-.041-.037z" />
      <path d="M55.959 46.759c-2.61-2.345-6.843-2.345-9.454 0l-.02.018-.02.019c-2.611 2.345-6.844 2.345-9.454 0l-.02-.019-.021-.018c-2.61-2.345-6.843-2.345-9.454 0l-.02.018-.02.019c-2.61 2.345-6.843 2.345-9.454 0l-.02-.019-.02-.018c-2.611-2.345-6.844-2.345-9.455 0l-.02.018-.02.019A6.799 6.799 0 016 48.206V56h50v-9.204l-.041-.037zM39.394 40.789c.483-.263 1.03-.182 1.428.203.549.533 1.592.642 2.166.66.19.006.324.19.273.373-.188.664-.975 1.336-2.114 1.336-.585 0-1.138-.127-1.559-.359-.46-.253-.732-.609-.765-1.003-.06-.711.278-1.05.571-1.21z" />
      <path d="M37.876 39.35a2.646 2.646 0 01-.617-1.694c0-1.464 1.183-2.656 2.636-2.656 1.454 0 2.637 1.192 2.637 2.656 0 .845-.402 1.629-1.07 2.122.908.818 2.364.667 3.08-.303a.293.293 0 01.436-.04c.652.612 1.011 1.368 1.011 2.127 0 1.896-2.067 3.438-4.61 3.438-2.53 0-4.589-1.542-4.589-3.438 0-.82.383-1.596 1.086-2.212zm1.53-2.348a.293.293 0 10-.584.059.293.293 0 00.584-.059zm-1.168 5.046c.055.647.492 1.152 1.067 1.468.505.278 1.16.43 1.84.43 1.395 0 2.416-.837 2.678-1.762a.879.879 0 00-.818-1.118c-.82-.025-1.483-.21-1.777-.495-.574-.556-1.398-.687-2.115-.297-.59.32-.945.933-.875 1.774zM36.263 37.19l.454-.063c-.1.61-.024 1.213.201 1.757a1.506 1.506 0 01-.908-1.404c0-.147.108-.27.253-.29z" />
      <circle cx="21" cy="25" r="4" />
      <path stroke={stroke} strokeWidth="4" strokeLinecap="round" d="M9.828 25.227l7.197 7.196" />
      <circle cx="21" cy="25" r="4" />
      <path d="M15 30h12v12.5c-2 1.5-4 2-6 1.5s-2-2-6-2V30z" />
      <path stroke={stroke} strokeWidth="4" strokeLinecap="round" d="M32.172 25.227l-7.197 7.196" />
    </svg>
  );
};
/* eslint-enable max-len */

PoolKids.defaultProps = {
  className: null,
};

PoolKids.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  stroke: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default PoolKids;
